import { api } from './client'

export const insightsApi = {
  get: (userId, token) => api.get(`/insights/${userId}`, token),
  home: (token) => api.get('/insights/home', token),
}
